import { render, staticRenderFns } from "./GesDocumentoPostulante.vue?vue&type=template&id=35f9febc&scoped=true&"
import script from "./GesDocumentoPostulante.vue?vue&type=script&lang=js&"
export * from "./GesDocumentoPostulante.vue?vue&type=script&lang=js&"
import style0 from "./GesDocumentoPostulante.vue?vue&type=style&index=0&id=35f9febc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f9febc",
  null
  
)

export default component.exports